import React, { useCallback, useContext, useState } from 'react';

const LayoutContext = React.createContext(null);

export const LayoutProvider = ({ children }) => {
    const [open, setOpen] = useState(false);

    const toggleMenu = useCallback(() => setOpen((open) => !open), []);

    return (
        <LayoutContext.Provider
            value={{
                open,
                setOpen,
                toggleMenu,
            }}
        >
            {children}
        </LayoutContext.Provider>
    );
};

LayoutProvider.displayName = 'LayoutProvider';

export const useLayout = () => useContext(LayoutContext);
